import styled from "styled-components";

export const GenrealInfo = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  box-shadow: 2px 2px 4px 1px rgba(0, 76, 127, 0.25);
  background-color: white;
  padding-bottom: 30px;
  border-radius: 4px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 10px;
`;

export const Title = styled.h2`
  color: #00aeea;
  font-size: 16px;
  font-family: lato;
  text-transform: initial;
  padding-top: 10px
  line-height: 1;
  margin-top: 3px;
  font-weight: bold !important;
  padding-left: 10px;
  justify-self: auto;
`;

export const FlexRow = styled.div`
  display: flex;
  align-items: center;
`;

export const ErrorContainer = styled.div`
  height: 60px;
  padding: 10px;
  border-radius: 4px;
  border: 1px;
  margin-bottom: 10px;
  font-size: 14px;
  background: #ea6457;
`;

export const GridRow = styled.div`
  display: grid;
  grid-template-columns: ${(props) => props.column};
  gap: ${(props) => (props?.gap ? props.gap : "1rem")};
  margin-bottom: 10px;
  opacity: ${(props) => (props?.opacity ? props.opacity : 1)};
  font-size: 14px;
  color: #ffffff;
`;

export const SubTitle = styled.div`
  justify-self: auto;
  color: ${(props) => props.color ?? "#004c7f"};
  font-size: 14px;
  font-weight: ${(props) => props.fontWeight ?? "400"};
  padding-left: ${(props) => props.paddingLeft ?? "20px"};
  padding-right: 1.375rem;
  margin-bottom: ${(props) => props.marginBottom ?? "20px"};
`;

export const MapContainer = styled.div`
  border-radius: 4px;
  position: relative;
  height: ${(props) => props.height ?? "160px;"};
  overflow: hidden;
  outline: none;
  box-shadow: 0px 4px 4px rgba(63, 56, 56, 0.25);
  margin: 0 1.375rem;
  width: auto;
  border: solid 1px #00aeea;
  margin-bottom: 10px;
  margin-top: ${(props) => props.marginTop ?? "0px;"};
`;

export const ShowMoreData = styled.span`
  text-decoration-line: underline !important;
  color: rgb(0, 76, 127) !important;
  cursor: pointer;
`;
